import React from 'react';
import asasPattern3 from "assets/asaspattern3.svg";
import classNames from 'utilities/ClassNames';

interface Block {
    id: string;
    status: string; // or union type e.g. "used" | "free" | "reserved"
    color: string;
}

interface Row {
    id: string;
    label: string;
    blocks: Block[];
}

interface MFDRoomCardProps {
    label: string;
    rows: Row[];
    setSelectedCrackScreen: React.Dispatch<React.SetStateAction<string | null>>;
}
const MFDRoomCard: React.FC<MFDRoomCardProps> = ({ label, rows, setSelectedCrackScreen }) => {
    return (
        <>
            <div className="flex flex-col gap-2 py-2   transform  
                transition-all duration-300 ease-in-out
                hover:-translate-y-1
                 hover:bg-[#061D2E] hover:rounded-md  hover:shadow-xl
                   border-2 border-transparent 
                hover:border-[#65F4CD] group card-con" onClick={() => setSelectedCrackScreen(label)}>
                <div className={`${label === "Crac-2" ? 'flex justify-end' : label === "Crac-3" ? "flex justify-between" : ""}`}>

                    <div className="px-2 py-1 w-[100px] bg-black rounded-md cursor-pointer group:hover:bg-[#0C3756] border border-white ml-1" >
                        <h3 className="text-[14px] text-center font-medium">{label}</h3>
                    </div>
                    {label === "Crac-3" && (
                        <div className="px-2 py-1 w-[100px] bg-black rounded-md cursor-pointer group:hover:bg-[#0C3756] border border-white ml-1" >
                            <h3 className="text-[14px] text-center font-medium">{label === "Crac-3" ? "Crac-4" : label}</h3>
                        </div>
                    )}
                </div>


                <div className="px-2 bg-[#0A3351] hover:bg-[#373d7e] group:hover:bg-[#373d7e] rounded-md h-[65vh] flex justify-center items-center w-full tiles-section ">
                    <div className="content bg-[#082a43] border border-[#134366] w-full ">
                        {rows.map((row, index) => (
                            <>
                                {/* Row */}
                                <div key={row.id} className="flex   pl-2 pl-3  bg-[#082a43] w-auto ">
                                    {/* Blocks */}
                                    <div className="grid grid-cols-15 gap-2 w-full">
                                        {row.blocks.map((block: any) => (
                                            <div
                                                key={block.id}
                                                className="p-2 flex items-center justify-center text-xs font-medium rounded border-2 font-[700] text-white [writing-mode:vertical-rl]"
                                                style={{
                                                    borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                                                    backgroundColor: block.color,
                                                    transform: "rotate(180deg)",
                                                }}
                                            >
                                                {block.id}
                                            </div>
                                        ))}
                                    </div>



                                    {/* Row Label */}
                                    <div className="row-title rounded-md  flex items-center justify-end w-[30px]">
                                        <h4 className="text-sm font-semibold text-white [writing-mode:vertical-rl] rotate-180  text-end">
                                            {row.label}
                                        </h4>
                                    </div>

                                </div>
                                {rows.length - 1 !== index && rows.length > 1 && (
                                    <img src={asasPattern3} alt="asas-pattern" className='w-full h-full' />
                                )}
                            </>
                        ))}

                    </div>

                </div>

                {label !== "Crac-2" && (

                    <div className={`${label === "Crac-3" ? "flex justify-center gap-5" : ""}`}>
                        <div className={classNames(label === 'Crac-1' ? 'bg-red/30 border-red' : label === 'Crac-3' ? 'bg-orange/30 border-orange' : 'border-white', "px-2 py-1 w-[100px] bg-black rounded-md cursor-pointer group:hover:bg-[#0C3756] border ml-1")} >
                            <h3 className="text-[14px] text-center font-medium">{label === "Crac-1" ? "Crac-5" : label === "Crac-3" ? "Crac-6" : ""}</h3>
                        </div>
                        {label === "Crac-3" && (
                            <div className="px-2 py-1 w-[100px] bg-black rounded-md cursor-pointer group:hover:bg-[#0C3756] border border-white ml-1" >
                                <h3 className="text-[14px] text-center font-medium">{label === "Crac-3" ? "Crac-7" : ""}</h3>
                            </div>
                        )}
                    </div>
                )}


            </div>
        </>
    );
};

export default MFDRoomCard;